import createFetchActions from './createFetchActions';

const getSurveyVideosIngestStatusAction = createFetchActions('GET_SURVEY_VIDEO_INGEST_STATUS');

export { getSurveyVideosIngestStatusAction };
